import React from 'react';
import {Modal, Spinner} from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import Countdown from "react-countdown";
import {client} from "helpers/client";
import {useQueryClient} from "react-query";
import {useStatus} from "hooks/use-status";
import {useTranslation} from "react-i18next";

interface Props {
    show:boolean,
    onHide: () => void,
    expire?: string,
    emailId?:number,
}

function LinkSentDialog({show,onHide,expire,emailId} :Props) {
    const {t} = useTranslation('security');
    const queryClient = useQueryClient();
    const {isLoading,load,stop,done} = useStatus();

    async function handleResendEmailVerification() {
      load();
      const { response } = await client(`/auth/resendForgetPasswordEmailLink/${emailId}`, { method: "POST" });
      if (response) {
        done();
        return queryClient.invalidateQueries("emails-data");
      } else stop();
    }

    return (
        <div>
            <Modal
                size="lg"
                centered
                show={show}
                className='all-modal restPassword'
            >
                <Modal.Body>
                    <div className='header'>
                        <img src={Back} alt='back' onClick={onHide}/>
                        <h1>{t('link-sent')}</h1>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <p>{t('password-reset-link-sent-to-you')}</p>
                            <p>{t('link-valid-for-1-hour')}</p>
                        </div>
                        <div className='col-12'>
                            <button className='btn-blue' onClick={onHide}>{t('ok')}</button>
                        </div>
                        <div className='col-12 mt-3'>
                           <Countdown date={expire ?? Date.now()} renderer={p => {
                               if(p.completed) return <button className='btn-White' disabled={isLoading} onClick={handleResendEmailVerification}>
                                   {isLoading && <Spinner animation='border' size='sm' /> }
                                   {t('send-again')}</button>
                               return  <button className='btn-White'>{p.formatted.hours}:{p.formatted.minutes}:{p.formatted.seconds}</button>
                           }} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default LinkSentDialog;